import React from 'react';
import styled from 'styled-components';
import { TogglePresentationButton } from './Nav/styles';
import { updatePresentationType } from '@services/sse';
import { setBrowserStorageItem } from '@utils/browserStorage';
import { BROWSER_STORAGE_KEYS, PresentationType } from '@constants';

const ToggleBanner = styled.div`
    position: relative;
    width: 95%;
    top: 5rem;
    display: flex;
    justify-content: center;
    border-radius: .25rem;
    padding: .75rem 1rem;
    background-color: #e9ecef;
`;

export const TogglePresentation = ({ currentlyViewing, setCurrentlyViewing }) => {
    const { SLIDES_PRESENTATION, DOCUMENTS_PRESENTATION } = PresentationType;

    function handlePresentationChange(event) {
        const { value } = event.target;
        const { presentationTypeKey } = BROWSER_STORAGE_KEYS;

        setCurrentlyViewing(value);
        updatePresentationType(value);
        setBrowserStorageItem(presentationTypeKey, value);
    }

    return (
        <ToggleBanner>
            <TogglePresentationButton 
                selected={currentlyViewing === SLIDES_PRESENTATION}
                value={SLIDES_PRESENTATION}
                onClick={handlePresentationChange}>
                    Slides
            </TogglePresentationButton>
            <TogglePresentationButton
                selected={currentlyViewing === DOCUMENTS_PRESENTATION}
                value={DOCUMENTS_PRESENTATION}
                onClick={handlePresentationChange}>
                    Documents
            </TogglePresentationButton>
        </ToggleBanner>
    );
};

export default TogglePresentation;
